module.exports = __webpack_public_path__ + "static/media/create-your-own.fc005f60.jpg";